import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

export const AppTextField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    return <TextField ref={ref} variant="outlined" size="small" {...props} />;
  }
);

AppTextField.displayName = 'AppTextField';
